import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import {
  DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService,
  DwUiConfigRegistryService, DwUIMetaDataConfigToken, DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService,
  DwComponentSectionConfigPreference, DevwareMetaDataService, DwQueryHelper, DwOrmDataServiceToken, DwOrmDataService, DwQuery, DwOrmData,
  DwEventTriggerTypeList, DwSecurityUserService, DwMetaDataFormStateService, formatDateTime, DwFormContextMode, DwModalService, DwConfirmDialogConfig
} from '@devwareapps/devware-cap';
import { DwFormControlLookupComponent } from '@devwareapps/devware-cap';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of } from 'rxjs';
import * as moment from 'moment';
import { map } from 'rxjs/operators';
import { AppMetaDataLookups, AppMetaDataItemNames, AppMetaDataService } from 'src/app/meta-data/app-meta-data.service';
import { NoteControlNewConfig } from '../models/note-control-new-config.model';
import { NoteControlNewConfigComponent } from './note-control-new-config/note-control-new-config.component';
import { NotesMetaDataService, NotesNoteParentEntity, NotesMetaDataItemNames, NotesNoteEntity } from '../../meta-data/notes-meta-data.service';
import { FormGroup, AbstractControl, FormControl } from '@angular/forms';
import { EditableNote, NotesRepositoryService } from '../../services/notes-repository-service';
import { number } from 'mathjs';
import { Router } from '@angular/router';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { SanitizeHtmlPipe } from './wachter-note-editor.component';
@DwComponent({
  key :'NoteControlNew',
  name: 'NoteControlNew',
  isGlobal: true,
  componentType: DwComponentType.formSection,
  configComponent: NoteControlNewConfigComponent
})
@Component({
  selector: 'app-note-control-new',
  templateUrl: './note-control-new.component.html',
  styleUrls: ['./note-control-new.component.scss']
})
export class NoteControlNewComponent
  extends DwSectionBaseComponent<DwComponentSectionConfigPreference<NoteControlNewConfig>> implements OnInit {

  comments: any[] = [];
  editing: any;
  priorCommentText : string = null;
  updatedCommentText : string = null;
  isNoteDirty : boolean = false;

  noteControlConfig: NoteControlNewConfig;
  hasDeletePermission = false;
  hasEditPermission = false;
  searchQuery: string;
  mode: DwFormContextMode;
  moment: any = moment;

  isSaving: boolean = false;
  isReadOnly: boolean = false;
  newComment?: string;
  autoDelete : boolean;

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    private dwSecurityUserService: DwSecurityUserService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwModalService: DwModalService,
    private notesRepository: NotesRepositoryService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private router: Router
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.autoDelete = false;
    this.mode = this.dwMetaDataFormStateService.state.formContext.contextMode;
    this.isReadOnly = this.mode == 'view';

    this.noteControlConfig = this.sectionConfig.config;
    this.hasDeletePermission = this.havePerm(this.noteControlConfig.CanDeletePermissionMeaning);
    this.hasEditPermission = this.havePerm(this.noteControlConfig.CanEditPermissionMeaning)

    // Call in a timeout since this creates a control which leads to an Angular Expression has changes after it was set exception
    setTimeout(() => {
      this.refreshComments();
    });

    // Subscribe to note events to custom actions can trigger a note refresh
    this.subscriptions.push(
      this.notesRepository.getNoteRefreshEvent(this.noteControlConfig.FilterListOnType ? this.noteControlConfig.NoteType : null)
        .subscribe(() => {
          this.refreshComments();
        })
    );

    const key: string = this.noteControlConfig.ReadOnlyKey ?? ""; 
    this.subscriptions.push(
      this.notesRepository.getNoteReadOnlyEvent(key)
          .subscribe((event) => {
            this.isReadOnly = event.readOnly ?? false;
          })
    );
  }

  getComments(): Observable<NotesNoteEntity[]> {
    const md = new AppMetaDataService();
    const qh = new DwQueryHelper();

    const control = this.getNoteParentControl();
    const noteParentId = control.value;

    if (noteParentId === null) {
      return of([]);
    }

    const notes = this.notesRepository.loadNotes(noteParentId, this.noteControlConfig.FilterListOnType, this.noteControlConfig.NoteType)
    
    return notes;
  }


  refreshComments() {
    var newComments: any[] = [];
    this.getComments().subscribe(results => {
      this.comments = results.map(note => this.createDisplayComment(<EditableNote>note));
    });

  }

  navToNoteSource(i) {
    const isPermit: boolean = AppMetaDataLookups.PermitAllItems == i.MetaDataLookupId;
    const isPermitRequest: boolean = AppMetaDataLookups.PermitRequestAllItems == i.MetaDataLookupId;
    if ((isPermit || isPermitRequest) == false) return;
    let url = isPermit ? '/project-tools/permits/permit-management' : '/project-tools/permits/permit-request';
    url = `${url}/${i.record.mode}/${i.RecordId}`;
    i.record.router.navigateByUrl(url);
  }

  createDisplayComment(newResult: EditableNote) {
    const showSrc = this.noteControlConfig.ShowNoteSource == true &&
      this.noteControlConfig.ExcludeNoteTypes.indexOf(newResult.NoteTypeId.toString()) == -1;
      return {
      "record": this,
      "id": newResult.NoteId,
      "navToSource": this.navToNoteSource,
      "RecordId": newResult.AccessoryData,
      "MetaDataLookupId": newResult.NoteType ? newResult.NoteType.MetaDataLookupId : 0,
      "ShowSource": showSrc,
      "CreatedBy": newResult.CreatedByEthosEthosUser.LastName + ', ' + newResult.CreatedByEthosEthosUser.FirstName,
      "CreatedOn": newResult.CreatedByDateTime,
      "ModifiedBy": newResult.ModifiedByEthosEthosUser ? newResult.ModifiedByEthosEthosUser.LastName + ', ' + newResult.ModifiedByEthosEthosUser.FirstName : null,
      "ModifiedOn": newResult.ModifiedByDateTime,
      "Comment": this.linkifyNote(newResult.Note),
      "parent" : newResult.NoteParentId,
      "entity" : newResult
    };
  }

  havePerm(perm: string): boolean {
    if (perm == undefined || perm == null) return false;
    return this.dwSecurityUserService.hasPermission(perm);
  }

  getNoteParentControl(): AbstractControl {
    return this.getOrCreateFormControl(this.noteControlConfig.NoteKey);
  }

  onAddNoteClicked() {
    let comment: string = this.newComment;
    this.newComment = null;

    if (this.noteControlConfig.NoteKey == null) {
      console.warn(`Form not yet configured`);
      return `Form not configured`;
    }
  
    if (!comment) return;
    comment = new RegExp('^<p>.*</p>$').test(comment) ? comment.substring(3,comment.length - 4) : comment;

    if (this.isSaving) return; // don't allow use to  save

    this.isSaving = true; // Mark as being saved - get cleared once note is saved

    this.getOrCreateNoteParentId().subscribe(noteParentId => this.addNote(comment, noteParentId))
  }

  getOrCreateNoteParentId(): Observable<number> {
    const noteParentIdControl = this.getNoteParentControl();

    const noteParentId = noteParentIdControl.value;

    // Check if we already have an id
    if (noteParentId) {
      return of(noteParentId);
    }

    return this.notesRepository.createNoteParent()
      .pipe(map(noteParentId => {
        noteParentIdControl.setValue(noteParentId);

        // if we're edting, we need to save the note parent id so it is saved if they exit the page before saving
        if (this.formConfig.formMode != DwFormContextMode.add) {
          this.notesRepository.saveDataWithNoteParentId(this.formConfig.rootItemName, this.formConfig.keyName, this.getKeyValue(), this.noteControlConfig.NoteKey, noteParentId);
        }

        return noteParentId;
      }))
  }

  addNote(comment: string, noteParentId: number) {
    let accessoryData: number;
    if (this.noteControlConfig.SaveRecordId) {
      accessoryData = this.getKeyValue();
    }

    this.notesRepository.createNote(comment, noteParentId, this.noteControlConfig.NoteType, accessoryData)
      .subscribe(savedNote => {
        // Add returned note to the array
        const displayComment = this.createDisplayComment(<EditableNote>savedNote);

        this.comments = [displayComment, ...this.comments];

        this.isSaving = false;
      });

    this.newComment = "";
  }

  getKeyValue() {
    const data = this.formGroup.getRawValue();

    return data[this.formConfig.keyName];
  }

  trackNote(index: number, note: any) {
    return note.id;
  }

  deleteNote(noteId: number) {

    this.notesRepository.deleteNote(noteId)
      .subscribe(x => {
        this.refreshComments();
      });
  }

  onDeleteNote(id: number, content) {
    //TODO switch to use built in 
    const confirmDialogConfig: DwConfirmDialogConfig = {
      message: 'Are you sure you want to delete this note?',
      title: 'Delete Note?', 
      showConfirmDialog: true,
    };

    if (this.autoDelete === true)
      this.approvedDelete(id);
    else
      this.dwModalService
          .showConfirmDialog(confirmDialogConfig)
          .subscribe(result => { if (result) this.approvedDelete(id); })
  }
  approvedDelete(id: number){
    this.clearNoteTracking();
    this.deleteNote(id);
  }
  clearNoteTracking(){ this.editing = null; this.priorCommentText = null; this.updatedCommentText = null; }
  setNoteTracking(n : any, prior : string, updated : string){
    this.editing = prior || updated ? this.editing : n;
    this.priorCommentText = prior ?? this.priorCommentText ?? updated ?? (n ? n.Comment : null);
    this.updatedCommentText = updated ?? this.updatedCommentText;
    
    var fromBlankToNot = (this.priorCommentText ?? '').length == 0 && (this.updatedCommentText ?? '').length > 0;
    var fromNonBlankToBlank = (this.priorCommentText ?? '').length > 0 && (this.updatedCommentText ?? '').length == 0;
    var modified = (this.priorCommentText ?? '').length > 0 && (this.updatedCommentText ?? '').length > 0
                  && this.priorCommentText != this.updatedCommentText;
    this.isNoteDirty = fromBlankToNot || fromNonBlankToBlank || modified;
    if (this.isNoteDirty){
      this.editing.Comment = this.updatedCommentText;
      this.editing.entity.Note = this.updatedCommentText;
    }
  }
  onEditNote(note: any, content) { 
    this.priorCommentText = note.Comment;
    this.updatedCommentText = note.Comment;
    this.setNoteTracking(note, null, null); 
  }
  isUnderEditAndChanged(note: any) : boolean {
    return this.editing && note.id === this.editing.id && note.Comment !== this.priorCommentText;
  }
  onUndoNoteEdit(note: any, content) {
    if (this.isUnderEditAndChanged(note)){
      this.editing.entity.Note = this.priorCommentText 
      this.editing.Comment = this.priorCommentText;
      note.Comment = this.priorCommentText;
    }
    this.clearNoteTracking();
  }
  onNewCommentUpdate(e){
    this.newComment = e;
  }
  onCommentChange(e){ 
    this.setNoteTracking(null, null, e); 
  }
  onSaveNoteChanges(note: any, content) {
    var fromNonBlankToBlank = (this.priorCommentText ?? '').length > 0 && (this.updatedCommentText ?? '').length == 0;

    this.editing = null;
    if (this.isUnderEditAndChanged(note) === false)
      return;
    else if (fromNonBlankToBlank) //Really deleting
      this.deleteNote(note.id);
    else {
        //TODO: switch to use built in 
        const confirmDialogConfig: DwConfirmDialogConfig = {
          message: `<div><b>Are you sure you want to save these changes?</b><br/><br/><u>Original Note:</u><br/><i>${this.priorCommentText}</i><br/><br/><u>Updated Note:</u><br/>${note.Comment}</div>`,
          title: 'Update Note?',
          showConfirmDialog: true,
        };
        this.dwModalService.showConfirmDialog(confirmDialogConfig)
          .subscribe(result => {
            if (result) {
              const entity : EditableNote = <EditableNote>note.entity;
              const wachterUser = new WachterUserExt(this.dwSecurityUserService.securityContext.ApplicationUser);
              entity.ModifiedByEthos_UserId = wachterUser.trustUserId;
              this.notesRepository.updateNote(entity).subscribe(savedNote => {
                setTimeout(() => {
                  this.refreshComments();
                });
              });
            }
            else
              this.onUndoNoteEdit(note, content);
              this.clearNoteTracking();
        })
      }
  }

  onSearch(searchQuery: string) {
    this.searchQuery = searchQuery;
  }

  private linkifyNote(text: string) {
    return text;
    // This logic actually breaks existing cut-n-pasted links/html anchor tags.
    // let urlRegex: RegExp = /(https?:\/\/[^\s]+)/g;
    // return text.replace(urlRegex, '<a href="$1" target="_blank">$1</a>');
  }
}

export interface NoteReadOnlyKey {
  Key?: string;
  ReadOnly?: boolean;
}
